// TestimonialsSection (new content)
import React from "react";

const testimonials = [
  {
    quote: "Fintorro’s AI explained my first chart better than any YouTube video ever could.",
    author: "– Anika, New Trader"
  },
  {
    quote: "The newsletter keeps me sharp. Every Monday I start with a plan — powered by AI.",
    author: "– Raj, Crypto Beginner"
  },
  {
    quote: "I finally understand trading psychology — the AI made it feel human.",
    author: "– Leo, Student Investor"
  }
];

const TestimonialsSection = () => (
  <section className="testimonials">
    <div className="container">
      <h2>AI That Speaks Your Language</h2>
      <div className="testimonials-grid">
        {testimonials.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <p className="quote">“{item.quote}”</p>
            <p className="author"><strong>{item.author}</strong></p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
